import { Injectable } from "@angular/core";
import {IndividualConfig, ToastrService} from "ngx-toastr";

export interface ToasterConfig extends IndividualConfig {}

@Injectable({
  providedIn: 'root'
})
export class ToasterService {

  constructor(private toastr: ToastrService) { }

  success(title: string, message: string) {
    this.toastr.success(message, title);
  }

  error(title: string, message: string) {
    this.toastr.error(message, title);
  }

  warning(title: string, message: string) {
    this.toastr.warning(message, title);
  }

  info(title: string, message: string) {
    this.toastr.info(message, title);
  }
}
